<template>
  <div class="employee-main-container">
    <!-- 顶部导航栏 -->
    <nav class="admin-nav-bar">
      <div class="logo">
        <img :src="tenantInfo.logoUrl ||  'https://xtsq-oss-hb.oss-cn-beijing.aliyuncs.com/sunrise-images/sunrise-logo.png'" width="40" height="40" alt="小晖智能客服"/>
        <span>小晖智能客服 · 员工工作台</span>
      </div>

      <!-- 用户操作区 -->
      <div class="user-actions">
        <span class="welcome-text">欢迎，{{ employeeInfo.realName }}</span>

        <div class="user-dropdown" ref="dropdownContainer" v-click-outside="closeDropdown">
          <div class="dropdown-trigger" @click.stop="toggleDropdown">
            <div class="avatar-group">
              <img
                :src="employeeInfo.avatar"
                class="user-avatar"
                alt="用户头像"
              >
              <span class="username">{{ userInfo.username }}</span>
              <i class="el-icon-arrow-down" :class="{ rotated: isDropdownOpen }"></i>
            </div>
          </div>

          <!-- 下拉菜单 -->
          <transition name="el-fade-in">
            <div v-show="isDropdownOpen" class="dropdown-menu">
              <div class="menu-item" @click="show_agreement">
                <svg style="margin-right: 8px;" t="1763807678190" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5574" width="16" height="16"><path d="M744.96 1000.96L179.2 998.4c-69.12 0-128-56.32-128-128V153.6c0-69.12 56.32-128 128-128h550.4c69.12 0 128 56.32 128 128v240.64c0 23.04-17.92 43.52-43.52 43.52-23.04 0-43.52-17.92-43.52-43.52V153.6c0-23.04-17.92-43.52-43.52-43.52H179.2c-23.04 0-43.52 17.92-43.52 43.52v719.36c0 23.04 17.92 43.52 43.52 43.52h565.76c46.08 0 69.12 15.36 69.12 43.52 0 25.6-23.04 40.96-69.12 40.96z m-481.28-235.52c-2.56 0-7.68 0-10.24-2.56-10.24-5.12-12.8-17.92-7.68-28.16 89.6-161.28 125.44-156.16 138.24-153.6 7.68 2.56 23.04 7.68 28.16 33.28 5.12 20.48 5.12 43.52 7.68 61.44v12.8l15.36-17.92c30.72-35.84 51.2-56.32 74.24-51.2 20.48 5.12 28.16 28.16 28.16 35.84 2.56 12.8 2.56 23.04 2.56 33.28 2.56-2.56 7.68-2.56 10.24-5.12 10.24-5.12 23.04 0 28.16 10.24 5.12 10.24 0 23.04-10.24 28.16-33.28 15.36-51.2 23.04-66.56 10.24-12.8-10.24-10.24-25.6-7.68-35.84 2.56-10.24 5.12-20.48 2.56-30.72-7.68 7.68-20.48 20.48-30.72 33.28l-17.92 17.92c-10.24 10.24-28.16 30.72-48.64 23.04-20.48-7.68-23.04-30.72-23.04-61.44 0-15.36-2.56-30.72-5.12-48.64-20.48 17.92-56.32 69.12-89.6 128-5.12 5.12-10.24 7.68-17.92 7.68z m-43.52-486.4h465.92v43.52H220.16v-43.52z m0 84.48h465.92v43.52H220.16v-43.52z m0 84.48h381.44v43.52H220.16v-43.52z m744.96 0l20.48 15.36c23.04 15.36 28.16 48.64 10.24 71.68l-199.68 276.48c-7.68 10.24-15.36 15.36-28.16 17.92l-81.92 23.04-2.56-84.48c0-10.24 2.56-23.04 10.24-30.72L893.44 460.8c17.92-23.04 48.64-28.16 71.68-12.8z" fill="#1296db" p-id="5575"></path></svg>
                <span>协议与隐私</span>
              </div>  

              <div class="menu-item" @click="AccountSettings">
                <i class="el-icon-user"></i>
                <span>账户设置</span>
              </div>
              <div v-if="loginType==='password'" class="menu-item" @click="ChangePassword">
                <i class="el-icon-lock"></i>
                <span>修改密码</span>
              </div>
              <div v-if="loginType==='sms'" class="menu-item" @click="passwordSetting_sms">
                <i class="el-icon-lock"></i>
                <span>设置密码</span>
              </div>
              <div class="menu-item" @click="change_phone">
                <i class="el-icon-user"></i>
                <span>更换手机号</span>
              </div>
              <div class="menu-divider"></div>
              <div class="menu-item logout" @click="logoutConfirm">
                <i class="el-icon-switch-button"></i>
                <span>退出登录</span>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </nav>

    <!-- 主内容区 -->
    <div class="admin-main">
      <!-- 侧边栏 -->
      <div class="sidebar" v-show="isDataLoaded">
        <div class="sidebar-header" v-if="tenantInfo">
          <div class="tenant-nickname">
            企业简称: {{ tenantInfo.nickname }}
          </div>
        </div>
        <ul class="sidebar-menu">
          <li
            @click="currentTab = 'dashboard'"
            :class="{active: currentTab === 'dashboard'}">
            <i class="el-icon-data-line"></i>
            <span>工作台</span>
          </li>
          <li
            @click="currentTab = 'kbWorkspace'"
            :class="{active: currentTab === 'kbWorkspace'}">
            <i class="el-icon-setting"></i>
            <span>知识库管理</span>
          </li>
          <li
            @click="currentTab = 'imagelibrary'"
            :class="{active: currentTab === 'imagelibrary'}">
            <svg t="1763975762449" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6712" width="16" height="16"><path d="M113.777778 341.105778l0 512.512C113.777778 884.906667 139.150222 910.222222 170.439111 910.222222l512.512 0C714.24 910.222222 739.555556 884.849778 739.555556 853.560889L739.555556 284.444444 170.439111 284.444444C139.093333 284.444444 113.777778 309.816889 113.777778 341.105778zM296.277333 388.721778c43.178667 0 78.222222 35.043556 78.222222 78.222222S339.512889 545.166222 296.277333 545.166222 218.055111 510.179556 218.055111 466.944 253.098667 388.721778 296.277333 388.721778zM179.143111 802.645333c0 0 21.731556-136.192 91.420444-136.192s61.383111 58.140444 113.777778 58.140444 74.012444-179.427556 144.440889-179.427556c70.428444 0 141.937778 258.389333 141.937778 258.389333 9.216 30.094222-8.476444 54.499556-40.106667 54.499556l-407.893333 0C191.374222 858.055111 171.292444 833.024 179.143111 802.645333z" fill="#1296db" p-id="6713"></path><path d="M170.666667 227.555556c0 15.701333 12.743111 28.444444 28.444444 28.444444l568.888889 0 0 568.888889c0 15.701333 12.743111 28.444444 28.444444 28.444444 15.701333 0 28.444444-12.743111 28.444444-28.444444l0-625.777778-625.777778 0C183.409778 199.111111 170.666667 211.854222 170.666667 227.555556z" fill="#1296db" p-id="6714"></path><path d="M256 113.777778C240.298667 113.777778 227.555556 126.520889 227.555556 142.222222S240.298667 170.666667 256 170.666667L853.333333 170.666667l0 597.333333c0 15.701333 12.743111 28.444444 28.444444 28.444444 15.701333 0 28.444444-12.743111 28.444444-28.444444L910.222222 113.777778 256 113.777778z" fill="#1296db" p-id="6715"></path></svg>
            <span>图片库管理</span>
          </li>          
          <li
            @click="currentTab = 'dialogue_history'"
            :class="{active: currentTab === 'dialogue_history'}">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" style="width: 20px;" ><path fill="currentColor" d="M160 826.88 273.536 736H800a64 64 0 0 0 64-64V256a64 64 0 0 0-64-64H224a64 64 0 0 0-64 64zM296 800 147.968 918.4A32 32 0 0 1 96 893.44V256a128 128 0 0 1 128-128h576a128 128 0 0 1 128 128v416a128 128 0 0 1-128 128z"></path><path fill="currentColor" d="M352 512h320q32 0 32 32t-32 32H352q-32 0-32-32t32-32m0-192h320q32 0 32 32t-32 32H352q-32 0-32-32t32-32"></path></svg>
            <span>查看对话记录</span>

          </li>
          <li
            @click="currentTab = 'stats'"
            :class="{active: currentTab === 'stats'}">
            <svg xmlns="http://www.w3.org/2000/svg" style="width: 20px;" viewBox="0 0 1024 1024" ><path fill="currentColor" d="M416 896V128h192v768zm-288 0V448h192v448zm576 0V320h192v576z"></path></svg>
            <el-icon><Histogram /></el-icon>
            <span>查看统计数据</span>

          </li>
        </ul>
      </div>

      <!-- 内容区 -->
      <div class="content">
        <!-- 加载状态 -->
        <div v-if="!isDataLoaded" class="loading-state">
          <el-skeleton :rows="1" animated />
        </div>
        <EmployeeDashboard v-if="currentTab === 'dashboard'" style="width: 100%;;height: 100%;"
               :tenantId="tenantInfo.tenantId" :username="userInfo.username"/>
        <EmployeeKbWorkspace v-if="currentTab === 'kbWorkspace'" style="width: 100%;;height: 100%;"
               :tenantId="tenantInfo.tenantId" :username="userInfo.username"
               @tab-change="handleTabChange" />
        <AdminKbDocument :workspaceSlug="workspaceSlug" 
                  :workspaceName="workspaceName" 
                  userType="employee"
                  v-if="currentTab === 'document'" style="width: 100%;;height: 100%;" 
                  :tenantId="tenantInfo.tenantId"/>
       <ImageLibrary :username="userInfo.username" 
       v-if="currentTab=='imagelibrary'"
        style="width: 100%; height: 100%;"/>

        <div v-if="currentTab === 'dialogue_history'" class="tab-content">
          <h2>AI客服配置</h2>
          <p>这里是员工任务管理区域</p>
        </div>
        <div v-if="currentTab === 'knowledge'" class="tab-content">
          <h2>知识库</h2>
          <p>这里是知识库浏览区域</p>
        </div>
        <div v-if="currentTab === 'settings'" class="tab-content">
          <h2>个人设置</h2>
          <p>这里是个人设置区域</p>
        </div>
      </div>
    </div>

    <!-- 退出确认对话框 -->
    <el-dialog
      title="确认退出"
      :visible.sync="dialogLogoutVisible"
      width="30%"
      @closed="handleLogoutDialogClose">
      <p>确定要退出登录吗？</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogLogoutVisible = false">取消</el-button>
        <el-button type="primary" @click="logout">确定</el-button>
      </span>
    </el-dialog>

    <!-- 账户设置对话框 -->
    <el-dialog
      title="账户设置"
      :visible.sync="dialogAccountSettingsVisible"
      width="30%"
      @closed="handleAccountSettingsDialogClose">
      <el-form ref="accountSettingsForm" :model="accountSettingsForm" label-width="100px">
        <label for="realName"> <span class="required-asterisk">*</span>真实姓名</label>
            <input
              v-model="accountSettingsForm.realName"
              type="text"
              id="realName"
              required
              placeholder="用于企业内部管理"/>
          <!--Logo Upload -->
          <div class="form-group">
            <div class="upload-container">
              <input
                type="file"
                id="logo"
                ref="avatarFile"
                accept="image/*"
                @change="handleFileUpload"
                class="file-input">
                <div class="upload-box" @click="triggerFileInput">
                <div v-if="!accountSettingsForm.avatarFile" class="upload-placeholder">
                  <span class="plus-icon">+</span>
                  <span class="upload-text">点击上传企业徽标(Logo)</span>
                </div>
                <div v-else class="file-preview">
                  <template v-if="isImageFile(accountSettingsForm.avatarFile) || previewImage">
                    <img :src="previewImage" class="thumbnail" alt="企业Logo预览">
                  </template>
                  <template v-else>
                    <span class="file-icon">📄</span>
                    <span class="file-name">{{ accountSettingsForm.avatarFile.name }}</span>
                  </template>
                  <button type="button" class="remove-btn" @click.stop="removeFile">×</button>
                </div>
              </div>
              <p class="form-note">请上传清晰的64x64px图片（支持JPG/PNG/JPEG格式）</p>
            </div>
          </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleAccountSettingsDialogClose">取消</el-button>
        <el-button type="primary" @click="handleAccountSettingsSubmit">
          <span v-if="!loading_accountSetting_submit">提交</span>
            <span v-else>
      <i class="el-icon-loading"></i> 提交中...
    </span>
        </el-button>
      </span>
    </el-dialog>

    <!-- 设置密码对话框 -->
    <el-dialog
      title="设置密码"
      :visible.sync="dialogPasswordSettings_smsVisible"
      width="400px"
      @closed="handlePasswordSettings_smsDialogClose">
      <el-form ref="passwordSettings_smsForm" :model="passwordSettings_smsForm" label-width="100px">
        <div class="form-group">
        <label for="username">账户名</label>
            <input
              v-model="passwordSettings_smsForm.username"
              id="username"
              type="text"
              readonly/>
        </div>
          <!--短信验证码 -->
          <div class="form-group">
            <label for="sms-code"><span class="required-asterisk">*</span>验证码</label>
            <div class="sms-group">
              <input
                id="sms-code"
                v-model="passwordSettings_smsForm.code"
                type="text"
                required
                placeholder="6位验证码"
                maxlength="6">
              <button
                type="button"
                class="sms-btn"
                :disabled="isCountingDown || !isPhoneValid"
                @click="sendSMSCode(userInfo.username)">
                <span v-if="!loading_sms"> {{ countdown > 0 ? `${countdown}s后重发` : '获取验证码' }}</span>
                <span v-else>
                  <i class="el-icon-loading"></i> 发送中...
                </span>
              </button>
            </div>
            <p v-if="smsError" class="error-message">{{ smsError }}</p>
          </div>
          <div class="form-group">
          <label for="username"><span class="required-asterisk">*</span>密码</label>
            <input v-model="passwordSettings_smsForm.password" id="password" type="password"/>
          </div>
          <div class="form-group">
          <label for="username"><span class="required-asterisk">*</span>确认密码</label>
            <input v-model="confirmPassword" id="confirm-password" type="password"/>
          </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handlePasswordSettings_smsDialogClose">取消</el-button>
        <el-button type="primary" @click="handlePasswordSettings_smsSubmit">
          <span v-if="!loading_accountSetting_submit">提交</span>
            <span v-else>
      <i class="el-icon-loading"></i> 提交中...
    </span>
        </el-button>
      </span>
    </el-dialog>

    <!-- 修改密码对话框 -->
    <el-dialog
      title="修改密码"
      :visible.sync="dialogChangePasswordVisible"
      width="400px"
      @closed="handleChangePasswordDialogClose">
      <el-form ref="changePasswordForm" :model="changePasswordForm" label-width="100px">
        <div class="form-group">
        <label for="username">账户名</label>
            <input
              v-model="changePasswordForm.username"
              id="username"
              type="text"
              readonly/>
        </div>
          <!--原密码 -->
          <div class="form-group">
            <label for="old-password"><span class="required-asterisk">*</span>原密码</label>
              <input
                id="old-password"
                v-model="changePasswordForm.oldPassword"
                type="password"
                required
                placeholder="请输入原密码">
            </div>
          <div class="form-group">
          <label for="new-password"><span class="required-asterisk">*</span>新密码</label>
            <input v-model="changePasswordForm.newPassword" id="new-password" type="password"/>
          </div>
          <div class="form-group">
          <label for="confirm-password"><span class="required-asterisk">*</span>确认密码</label>
            <input v-model="confirmPassword" id="confirm-password" type="password"/>
          </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleChangePasswordDialogClose">取消</el-button>
        <el-button type="primary" @click="handleChangePasswordSubmit">
          <span v-if="!loading_accountSetting_submit">提交</span>
            <span v-else>
      <i class="el-icon-loading"></i> 提交中...
    </span>
  </el-button>
      </span>

    </el-dialog>

    <!-- 更换手机号对话框 -->
    <el-dialog
          title="更换手机号"
          :visible.sync="dialogChangePhoneVisible"
          width="400px"
          @closed="handleChangePhoneDialogClose">
          <el-form ref="changeAdminForm" :model="changePhoneForm" label-width="100px">
            <div class="form-group">
            <label for="username">原手机号</label>
                <input
                  v-model="changePhoneForm.username"
                  id="username"
                  type="text"
                  readonly/>
            </div>
            <div class="form-group">
              <label for="new-password"><span class="required-asterisk">*</span>验证码</label>
                <input v-model="changePhoneForm.code1" id="code1" placeholder="原手机验证码" type="text"/>
              </div>
              <!--新手机号 -->
              <div class="form-group">
                <label for="newPhone"><span class="required-asterisk">*</span>新手机号</label>
                  <input
                    id="newPhone"
                    v-model="changePhoneForm.newPhone"
                    type="text"
                    placeholder="请输入新手机号">

                </div>
                <div class="form-group">
              <label for="code2"><span class="required-asterisk">*</span>验证码</label>
                <input v-model="changePhoneForm.code2" id="code2" placeholder="新手机验证码" type="text"/>
              </div>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button type="warning" @click="sendSMSCode_change_phone">发送验证码</el-button>
            <el-button @click="handleChangePhoneDialogClose">取消</el-button>
            <el-button type="primary" @click="handleChangePhoneSubmit">
              <span v-if="!loading_changePhone_submit">提交</span>
                <span v-else>
          <i class="el-icon-loading"></i> 提交中...
        </span>
            </el-button>
          </span>

    </el-dialog>
    <!-- 协议与隐私 -->
    <el-dialog
      title="协议与隐私"
      :visible.sync="dialogAgreementVisible"
      width="80%"
    >
    <AgreementView :userInfo="userInfo"  />
    </el-dialog>     
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { postBaseinfo } from '@/api/employee/settings'
import { send_sms_code } from '@/api/common'
import { set_password_sms,change_password, change_phone } from '@/api/auth/user'
import { getUserPermission } from '@/api/employee/dashboard'
import EmployeeDashboard from '@/components/employee/dashboard.vue'; //仪表盘组件
import EmployeeKbWorkspace from '@/components/employee/KbWorkspace.vue'; //仪表盘组件
import AdminKbDocument from '@/components/admin/KbDocuments.vue'; //知识库文档组件
import ImageLibrary from '@/components/aics/ImageLibrary.vue';
import AgreementView from '@/components/Agreement.vue'

import DEFAULT_USER_AVATAR from '@/api/base';

export default {
  name: 'EmployeeWorkspace',
  components: {
    EmployeeDashboard,
    EmployeeKbWorkspace,
    AdminKbDocument,
    ImageLibrary,
    AgreementView
  },
  directives: {
    'click-outside': {
      bind(el, binding) {
        el.clickOutsideEvent = function(event) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event);
          }
        };
        document.addEventListener('click', el.clickOutsideEvent);
      },
      unbind(el) {
        document.removeEventListener('click', el.clickOutsideEvent);
      }
    }
  },
  data() {
    return {
      isDropdownOpen: false,
      currentTab: 'dashboard',
      dialogLogoutVisible: false,
      dialogAccountSettingsVisible: false,
      dialogPasswordSettings_smsVisible: false,
      dialogChangePasswordVisible: false,
      dialogChangePhoneVisible: false,
      dialogAgreementVisible: false,
      imageLibrary: false,
      passwordSettings_smsForm:{
        username: '',
        code: '',
        password: '',
      },
      changePasswordForm: {
        username: '',
        oldPassword: '',
        newPassword: ''
      },
      confirmPassword: '',
      loading_sms: false,
      isPhoneValid: false,
      smsError: '',
      countdown: 0,
      isDataLoaded: false,
      previewImage: null,
      loading_accountSetting_submit: false,
      accountSettingsForm: {
        realName: '',
        avatarFile: null,
        previewImage: null,
      },
      passwordRules: {
        minLength: 6,
        maxLength: 20,
        requireLetter: true,
        requireNumber: true
      },
      loading_changePhone_submit: false, // 加载状态
      changePhoneForm: {
        username: '',
        code1: '',
        code2: '',
        newPhone: '',

      },
    }
  },
  computed: {
    ...mapState('auth', ['tenantInfo', 'userInfo','loginType','employeeInfo']),
    isCountingDown() {
      return this.countdown > 0
    }
  },
  created() {
      if (this.employeeInfo == null) {
        this.$router.push('/login')
        return
      }
      console.log('userInfo', this.userInfo)
      console.log('tenantInfo', this.tenantInfo)
      console.log('employeeInfo', this.employeeInfo);
      if (this.employeeInfo.avatar == null || this.employeeInfo.avatar == '') {
        this.employeeInfo.avatar = 'https://xtsq-oss-hb.oss-cn-beijing.aliyuncs.com/sunrise/default_avatar.png'
      }
      console.log('avatar', this.employeeInfo.avatar);
      this.isPhoneValid = /^1[3-9]\d{9}$/.test(this.userInfo.username)
      this.checkCountdown();
      console.log('isPhoneValid', this.isPhoneValid)
      console.log('loginType', this.loginType)
      console.log('tenantInfo', this.tenantInfo);
      if(this.tenantInfo.logoUrl == null){
        this.tenantInfo.logoUrl = DEFAULT_USER_AVATAR;
      }

      // 获取员工权限
      getUserPermission( this.userInfo.username).then( response => {
        console.log(response);
        this.isDataLoaded = true;
        if(response.code == 200){
           this.imageLibrary = response.data.imageLibrary
        }

      });

  },
  methods: {
    ...mapActions('auth', ['logout']),
    validatePhone(phone) {
      this.isPhoneValid = /^1[3-9]\d{9}$/.test(phone)
      if (!this.isPhoneValid) {
        this.$message.error('请输入正确的手机号')
      }
      return this.isPhoneValid
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen
    },
    checkCountdown() {
      console.log('checkCountdown');
      const savedTime = localStorage.getItem('smsCountdown');
      console.log(savedTime);
      if (savedTime) {
        const remainingTime = Math.ceil((parseInt(savedTime) - Date.now()) / 1000);
        if (remainingTime > 0) {
          this.countdown = remainingTime;
          this.startCountdown();
        } else {
          localStorage.removeItem('smsCountdown');
        }
      }
    },
    closeDropdown() {
      this.isDropdownOpen = false
    },
    ChangePassword(){
      this.closeDropdown()
      this.changePasswordForm.username = this.userInfo.username;
      this.dialogChangePasswordVisible = true
    },
    validatePassword(pwd) {
      if (!pwd) {
        this.$message.error('请输入密码');
        return false;
      }
      if (pwd.length < this.passwordRules.minLength) {
        this.$message.error(`密码至少需要${this.passwordRules.minLength}位`);
        return false;
      }
      if (pwd.length > this.passwordRules.maxLength) {
        this.$message.error(`密码最长${this.passwordRules.maxLength}位`);
        return false;
      }
      if (this.passwordRules.requireLetter && !/[a-zA-Z]/.test(pwd)) {
        this.$message.error('密码需包含字母');
        return false;
      }
      if (this.passwordRules.requireNumber && !/\d/.test(pwd)) {
        this.$message.error('密码需包含数字');
        return false;
      }
      return true;
    },
    async handleChangePasswordSubmit() {
      if(this.changePasswordForm.oldPassword===""){
        this.$message.error('原密码不能为空');
        return;
      }
      if(!this.validatePassword(this.changePasswordForm.newPassword)){
        return;
      }
      console.log('changePasswordForm', this.changePasswordForm);
      if (this.changePasswordForm.newPassword !== this.confirmPassword) {
        this.$message.error('两次输入的密码不一致');
        return;
      }

      change_password(this.changePasswordForm).then(response => {
        console.log('change_password response', response);
        if (response && response.code === 200) {
          this.$message.success('修改密码成功');
          this.dialogChangePasswordVisible = false; // 关闭对话框
        } else {
          this.$message.error('修改密码失败');
        }
      }).catch(error => {
        console.error('change_password error', error);
        this.$message.error('修改密码失败'+error);
      });
    },
    logoutConfirm() {
      this.dialogLogoutVisible = true
      this.closeDropdown()
    },
    handleLogoutDialogClose() {
      this.dialogLogoutVisible = false
    },
    AccountSettings() {
      this.closeDropdown()
      this.accountSettingsForm.realName = this.employeeInfo.realName;
      this.accountSettingsForm.previewImage = this.employeeInfo.avatar;
      this.dialogAccountSettingsVisible = true
    },
    passwordSetting_sms() {
      this.closeDropdown()
      this.passwordSettings_smsForm.username = this.userInfo.username;
      this.passwordSettings_smsForm.code = '';
      this.passwordSettings_smsForm.password = '';
      this.passwordSettings_smsForm.confirmPassword = '';
      this.dialogPasswordSettings_smsVisible = true
    },
    changePassword() {
      this.closeDropdown()
      this.changePasswordForm.username = this.userInfo.username;
      this.dialogChangePasswordVisible = true
    },
    triggerFileInput() {
      console.log(this.accountSettingsForm.avatarFile)
      if (this.accountSettingsForm.avatarFile==null) {
        this.$refs.avatarFile.click();
      }
    },
    handleAccountSettingsDialogClose() {
      this.dialogAccountSettingsVisible = false
    },
    handlePasswordSettings_smsDialogClose() {
      this.dialogPasswordSettings_smsVisible = false
    },
    async logout() {
      try {
        await this.$store.dispatch('auth/logout')
        this.$router.push('/login')
      } catch (error) {
        console.error('退出登录失败:', error)
        this.$store.commit('auth/CLEAR_AUTH')
        this.$router.push('/login')
      }
    },
    isImageFile(file) {
      return file && file.type.match('image.*')
    },
    handleFileUpload(event) {
      const file = event.target.files[0]
      if (file) {
        if (file.size > 5 * 1024 * 1024) {
          this.$message.error('文件大小不能超过5MB')
          return
        }
        this.accountSettingsForm.avatarFile = file
        if (this.isImageFile(file)) {
          const reader = new FileReader()
          reader.onload = (e) => {
            this.previewImage = e.target.result
          }
          reader.readAsDataURL(file)
        } else {
          this.previewImage = null
        }
      }
    },
    removeFile() {
      this.accountSettingsForm.avatarFile = null
      this.previewImage = null
      this.$refs.avatarFile.value = ''
    },
    async handlePasswordSettings_smsSubmit() {
      if (this.passwordSettings_smsForm.code=== ''){
        this.$message.error('请输入验证码');
        return;
      }
      if(!this.validatePassword(this.passwordSettings_smsForm.password)){
        return;
      }
      if (this.confirmPassword==='' || this.confirmPassword===null ||this.confirmPassword== undefined) {
        this.$message.error('两次输入的密码不一致');
        return;
      }
      if (this.passwordSettings_smsForm.password !== this.confirmPassword) {
        this.$message.error('两次输入的密码不一致');
        return;
      }

      set_password_sms(this.passwordSettings_smsForm).then(response => {
        console.log('set_password_sms response', response);
        if (response && response.code === 200) {
          this.$message.success('设置密码成功');
          this.dialogPasswordSettings_smsVisible = false;
        }
        else {
          this.$message.error('设置密码失败');
          return
        }
      }).catch(error => {
        console.error('set_password_sms error', error);
        this.$message.error('设置密码失败'+error);
      });
    },
    async handleAccountSettingsSubmit() {
      if(this.accountSettingsForm.realName===""){
        this.$message.error('真实姓名不能为空');
        return;
      }
      console.log("企业信息:", this.tenantInfo);
      console.log("用户信息:", this.userInfo);
      this.loading_register = true;
      let response = null
      try {
        const formData = new FormData();
        let tenantId = this.tenantInfo?.tenantId;
        formData.append('tenantId', tenantId);
        formData.append('realName', this.accountSettingsForm?.realName);
        formData.append('username', this.userInfo.username);
        if (this.accountSettingsForm.avatarFile) {
          formData.append('avatarFile', this.accountSettingsForm?.avatarFile);
        }
        console.log("使用的企业ID:", tenantId);
        response = await postBaseinfo(formData);
        console.log("saveBrief response:",response);

        if (response && response.data && response.data.code === 200) {
          this.dialogAccountSettingsVisible = false;
          this.$message.success("提交成功");
          this.employeeInfo.avatarFile = this.accountSettingsForm.avatarFile;

          if (this.accountSettingsForm.avatarFile) {
            this.employeeInfo.avatar = response.data.message;
            this.employeeInfo.realName = this.accountSettingsForm.realName;
          }
        } else {
          const errorMsg = (response.data && response.data.message) || '提交失败';
          this.$message.error(errorMsg);
        }
      } catch (error) {
        const errorMsg = (response.data && response.data.message) || '注册失败';
        this.$message.error(errorMsg);
      } finally {
        this.loading_register = false;
      }
    },
    async sendSMSCode(phone) {
      if (this.isCountingDown || !this.validatePhone(phone)) return;
      try {
        const response = await send_sms_code(phone)
        console.log(response);
        if (response.data &&response.status===200 && response.data.code === 200) {
          this.startCountdown();
          this.$message.success('验证码已发送');
          this.smsError = '';
        } else {
          this.$message.error((response.data && response.data.message) || '发送验证码失败');
        }
      } catch (error) {
        this.$message.error(error);
      }
    },
    startCountdown() {
      this.countdown = 60;
      localStorage.setItem('smsCountdown', Date.now() + 60000);
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer);
          localStorage.removeItem('smsCountdown');
        }
      }, 1000);
    },
    async checkTokenAndRefresh() {
    const token = this.$store.state.auth.token
    const refreshToken = this.$store.state.auth.refreshToken

    if (refreshToken && (!token || this.isTokenExpired(token))) {
      try {
        await this.$store.dispatch('auth/refreshToken')
        return true
      } catch (error) {
        console.error('Token刷新失败:', error)
        return false
      }
    }
    return true
    },

    isTokenExpired(token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]))
        return payload.exp * 1000 < Date.now()
      } catch (e) {
        return true
      }
    },
    handleChangePasswordDialogClose() {
        this.dialogChangePasswordVisible = false
    },
    change_phone(){
      this.closeDropdown()
      console.log('change_phone',this.userInfo);
      this.changePhoneForm.username = this.userInfo.username;
      this.dialogChangePhoneVisible = true

    },
    handleChangePhoneDialogClose() {
      this.dialogChangePhoneVisible = false
    },
    async handleChangePhoneSubmit() {
      if(this.changePhoneForm.code1===""){
        this.$message.error('请输入原手机验证码');
        return;
      }
      if(this.changePhoneForm.newPhone===""){
        this.$message.error('请输入新手机号码');
        return;
      }
      if(this.changePhoneForm.newPhone===this.changePhoneForm.username){
        this.$message.error('新手机号码不能与原手机号码相同');

        return;
      }
      if(this.changePhoneForm.code2===""){
        this.$message.error('请输入新手机验证码');
        return;
      }
      if(this.changePhoneForm.newName===""){
        this.$message.error('请输入新姓名');
        return;
      }
      console.log('changePhoneForm', this.changePhoneForm);
      change_phone(this.changePhoneForm).then(response => {
        console.log('change_phone response', response);
        if (response && response.code === 200) {
          this.$message.success('更换手机号成功,当前用户已经不能使用了，需要重新登录');
          this.dialogChangePhoneVisible = false; // 关闭对话框
          this.logout();
        } else {
          this.$message.error('更换手机号失败');
        }
      }).catch(error => {
        console.error('change_phone error', error);
        this.$message.error('更换手机号失败:'+error);
      });
    },
    async sendSMSCode_change_phone() {
      let phone = this.changePhoneForm.username+","+ this.changePhoneForm.newPhone;
      if (this.isCountingDown || !this.validatePhone(this.changePhoneForm.newPhone)) return;

      try {
        const response = await send_sms_code(phone)
        console.log(response);
        if (response.data &&response.status===200 && response.data.code === 200) {
          this.startCountdown();
          this.$message.success('已经给2个手机号发送验证码，请分别填入对应手机号下面的验证码文本框');
          this.smsError = '';
        } else {
          this.$message.error((response.data && response.data.message) || '发送验证码失败');
        }
      } catch (error) {

        this.$message.error(error);
      }
    },
     // 处理标签切换
 handleTabChange(tab, slug,name) {
      this.currentTab = tab
      this.workspaceSlug = slug || ''
      this.workspaceName = name || ''
    },
    async show_agreement(){
      this.dialogAgreementVisible = true;
    }    
  }
}

</script>

<style scoped lang="scss">
// 员工主页专属配色变量
$primary-color: #4CAF50;
$secondary-teal: #4ECDC4;
$hover-color: rgba(76, 175, 80, 0.1);
$text-color: #333;
$background-light: #F9F9F9;
$border-light: #E1E8ED;
$text-dark: #2F4858;

.employee-main-container {
  background: $background-light;
  font-family: 'Alibaba PuHuiTi', sans-serif;
  min-height: 100vh;
}

/* 导航栏 */
.admin-nav-bar {
  position: sticky;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 30px;
  background: linear-gradient(135deg, $primary-color, $secondary-teal);
  box-shadow: 0 2px 12px rgba($primary-color, 0.3);
  z-index: 9999;

  .logo {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 1.1rem;
    color: white;
    font-weight: 600;

    span {
      text-shadow: 0 1px 2px rgba(0,0,0,0.1);
    }
  }
}

/* 用户操作区 */
.user-actions {
  position: relative;
  display: flex;
  align-items: center;
  gap: 15px;

  .welcome-text {
    font-size: 0.8rem;
    color: rgba(255,255,255,0.9);
  }
}

.user-dropdown {
  position: relative;
  display: inline-block;
}

.avatar-group {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background: rgba(255,255,255,0.2);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background: rgba(255,255,255,0.3);
  }
}

.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid rgba(255,255,255,0.3);
}

.username {
  font-size: 0.85rem;
  color: white;
  font-weight: 500;
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.el-icon-arrow-down {
  font-size: 0.8rem;
  color: white;
  transition: transform 0.3s;

  &.rotated {
    transform: rotate(180deg);
  }
}

/* 下拉菜单 */
.dropdown-menu {
  position: absolute;
  right: 0;
  top: calc(100% + 5px);
  min-width: 180px;
  background: white;
  border-radius: 6px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.15);
  border: 1px solid $border-light;
  z-index: 10000;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  font-size: 0.9rem;
  color: $text-dark;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: rgba($secondary-teal, 0.1);
    color: $primary-color;

    i {
      color: $primary-color;
    }
  }

  i {
    margin-right: 10px;
    font-size: 1rem;
    color: $secondary-teal;
  }
}

.menu-divider {
  height: 1px;
  background: $border-light;
  margin: 4px 0;
}

.menu-item.logout {
  color: #f56c6c;

  i {
    color: #f56c6c;
  }

  &:hover {
    background: #fef0f0;
  }
}

/* 主内容区 */
.admin-main {
  display: flex;
  flex: 1;
  min-width: 1200px; /* 设置最小宽度防止压缩 */  
}

/* 侧边栏 - 清新风格 */
.sidebar {
  width: 220px;
  flex-shrink: 0; /* 防止侧边栏被压缩 */
  background: white;
  border-right: 1px solid $border-light;
  padding: 20px 0;
  box-shadow: 2px 0 5px rgba(0,0,0,0.02);
  transition: all 0.3s;
}

.sidebar-header {
  padding: 0 20px 20px;
  border-bottom: 1px solid $border-light;
  margin-bottom: 15px;

  .tenant-nickname {
    font-size: 0.8rem;
    color: $text-dark;
    background: rgba($secondary-teal, 0.1);
    padding: 8px 10px;
    border-radius: 4px;
    word-break: break-all;
    min-width: 10px;
    overflow: hidden;
  }
}

.sidebar-menu {
  list-style: none;
  padding: 0;
  margin: 0;
}

.sidebar-menu li {
  padding: 12px 25px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
  color: $text-dark;
  transition: all 0.2s;
  position: relative;

  i {
    font-size: 1.1rem;
    color: $secondary-teal;
  }

  &:hover {
    background: rgba($secondary-teal, 0.1);
    color: $primary-color;

    i {
      color: $primary-color;
    }
  }

  &.active {
    background: rgba($primary-color, 0.1);
    color: $primary-color;
    border-right: 3px solid $primary-color;

    i {
      color: $primary-color;
    }
  }
}

.content {
  flex: 1;
  padding: 30px;
  position: relative;
  background: $background-light;
}

.tab-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.loading-state {
  padding: 20px;
}

/* 响应式设计 */
@media (max-width: 992px) {
  .dashboard-charts {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .sidebar {
    width: 60px;

    span {
      display: none;
    }

    li {
      justify-content: center;
      padding: 12px 0;
    }
  }

  .user-actions {
    gap: 8px;
  }

  .welcome-text {
    display: none;
  }
}

/* 表单样式 */
#realName {
  flex: 1;
  padding: 12px 15px;
  border: 1px solid $border-light;
  border-radius: 6px;
  font-size: 1rem;
  transition: all 0.3s;
  width: 65%;
  background: rgba(240, 244, 249, 0.5);
  margin-left: 20px;

  &:focus {
    border-color: $primary-color;
    box-shadow: 0 0 0 3px rgba($primary-color, 0.2);
  }
}

.upload-container {
  margin-top: 10px;
  width: 100%;
}

.file-input {
  display: none;
}

.required-asterisk {
  color: #ff4d4f;
  margin-right: 4px;
}

.upload-box {
  display: block;
  width: 100%;
  height: 120px;
  border: 2px dashed $border-light;
  border-radius: 8px;
  background-color: rgba(240, 244, 249, 0.5);
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
  overflow: hidden;

  &:hover {
    border-color: $primary-color;
    background-color: rgba($primary-color, 0.05);
  }
}

.upload-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #999;
}

.plus-icon {
  font-size: 2rem;
  font-weight: lighter;
  margin-bottom: 8px;
  color: $primary-color;
}

.upload-text {
  font-size: 0.9rem;
}

.file-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0 20px;
  position: relative;
}

.thumbnail {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.file-name {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 30px;
}

.remove-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #ff4d4f;
  color: white;
  border: none;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &:hover {
    background: #ff7875;
  }
}

.form-group {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  margin-left: 0;
  padding-left: 0;

  label {
    flex: 0 0 80px;
    margin-bottom: 0;
    padding-right: 15px;
    text-align: right;
    font-weight: 500;
    color: #474747;
  }

  input {
    flex: 1;
    padding: 12px 15px;
    border: 1px solid $border-light;
    border-radius: 6px;
    font-size: 1rem;
    transition: all 0.3s;
    background: rgba(240, 244, 249, 0.5);

    &:focus {
      border-color: $primary-color;
      box-shadow: 0 0 0 3px rgba($primary-color, 0.2);
    }
  }
}

#sms-code {
  width: 130px;
}

.sms-group {
  display: flex;
  align-items: center;
  gap: 10px;

  input {
    flex: 1;
    min-width: 0;
  }

  .sms-btn {
    background: $primary-color;
    color: white;
    border: none;
    padding: 0 15px;
    height: 44px;
    border-radius: 6px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s;
    white-space: nowrap;

    &:disabled {
      background: #DDD;
      cursor: not-allowed;
    }

    &:not(:disabled):hover {
      background: darken($primary-color, 10%);
    }
  }
}

.error-message {
  color: #ff4d4f;
  font-size: 0.8rem;
  margin-top: 5px;
}

.form-note {
  font-size: 0.8rem;
  color: #999;
  margin-top: 8px;
}
</style>